
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BcDocumentType } from 'enums/BcDocumentType';
import { Model, ModelProperty } from 'models/Model';


export class CustomerLedgerEntryModel extends Model<CustomerLedgerEntryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'entryNo', type: 'number' },
		{ name: 'customerNo', type: 'string' },
		{ name: 'postingDate', type: 'Date' },
		{ name: 'documentType', type: 'BcDocumentType' },
		{ name: 'documentNo', type: 'string' },
		{ name: 'description', type: 'string' },
		{ name: 'currencyCode', type: 'string' },
		{ name: 'dimensionCode1Product', type: 'string' },
		{ name: 'dimensionCode2Department', type: 'string' },
		{ name: 'amount', type: 'number' },
		{ name: 'amountInclVat', type: 'number' },
		{ name: 'remainingAmount', type: 'number' },
		{ name: 'remainingAmountInclVat', type: 'number' },
		{ name: 'open', type: 'boolean' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'onHold', type: 'string' },
		{ name: 'externalDocumentNo', type: 'string' }
	];
	[key: string]: any;
	
	public entryNo?: number;
	public customerNo: string;
	public postingDate?: Date;
	public documentType: BcDocumentType;
	public documentNo: string;
	public description: string;
	public currencyCode: string;
	public dimensionCode1Product: string;
	public dimensionCode2Department: string;
	public amount?: number;
	public amountInclVat?: number;
	public remainingAmount?: number;
	public remainingAmountInclVat?: number;
	public open?: boolean;
	public dueDate?: Date;
	public onHold: string;
	public externalDocumentNo: string;
    
	constructor(){
		super();
		this.entryNo = undefined;
		this.customerNo = '';
		this.postingDate = undefined;
		this.documentType = 0;
		this.documentNo = '';
		this.description = '';
		this.currencyCode = '';
		this.dimensionCode1Product = '';
		this.dimensionCode2Department = '';
		this.amount = undefined;
		this.amountInclVat = undefined;
		this.remainingAmount = undefined;
		this.remainingAmountInclVat = undefined;
		this.open = undefined;
		this.dueDate = undefined;
		this.onHold = '';
		this.externalDocumentNo = '';
		
	}
	getProperties(){
		return CustomerLedgerEntryModel.classProperties;
	}
}

